import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { NotesText } from 'shell/models/notes-text';
import { AxiosResponse } from 'axios';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

interface AnnotationVM extends ItemVM {
  description?: string;
}

interface SelectAnnotationProps {
  disabled?: boolean;
  error?: boolean;
  value: string;
  label?: string;
  onChange: (event: SelectChangeEvent<string>, item?: AnnotationVM) => void;
  id: string;
  type: string;
}

const SelectAnnotationComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Annotazione',
  id,
  type,
}: SelectAnnotationProps): React.ReactElement => {
  const [annotation] = useHttpFetch<HttpResponseList<NotesText>, Array<AnnotationVM>>(
    `${__CIVIL_STATUS_API_URL__}/testo-annotazione/tipo/${type}`,
    {
      onBootstrap: true,
      transformer: (response: AxiosResponse<HttpResponseList<NotesText>>) => {
        const { data } = response;

        return data?.payload.list
          .map((item) => ({
            id: item.key.idAnnotazione,
            value: item.titolo,
            description: item.annotazione,
          }))
          .sort((a, b) => {
            if (a.value > b.value) return 1;
            if (a.value < b.value) return -1;
            return 0;
          }) as Array<AnnotationVM>;
      },
    }
  );

  const list = (annotation.data as Array<AnnotationVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error}>{label}</InputLabel>
      <PmiSelect
        id={id}
        name={id}
        value={value}
        onChange={(event) =>
          onChange(
            event,
            list.find((item) => item.id === event.target.value)
          )
        }
        disabled={disabled}
        label={label}
        error={error}
      >
        {list.map((item: AnnotationVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

SelectAnnotationComponent.displayName = 'List annotation component';

const SelectAnnotation = memo(SelectAnnotationComponent);

export default SelectAnnotation as typeof SelectAnnotationComponent;
